export const resultTypes = {
  APPROVED: { label: 'approved', type: 'is-primary' },
  REFUSED: { label: 'refused', type: 'is-danger' },
  WITH_OFFER: { label: 'with offer', type: 'is-warning' },
  WITHOUT_OFFER: { label: 'without offer', type: 'is-danger' },
  REVIEW: { label: 'review', type: 'is-warning' },
  ELIGIBLE: { label: 'eligible', type: 'is-success' },
  NOT_ELIGIBLE: { label: 'not eligible', type: 'is-danger' },
  NEUTRAL: { label: '-', type: 'is-danger' }
};
